import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-link-international-online-payment-details',
  templateUrl: './link-international-online-payment-details.component.html',
  styleUrls: ['./link-international-online-payment-details.component.scss']
})
export class LinkInternationalOnlinePaymentDetailsComponent implements OnInit,OnDestroy {
  loader: boolean = false;
  apisub: Subscription
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private ls: LoaderServiceService,
    private apiservice: ApiService,
    private activemodal: MatDialogRef<LinkInternationalOnlinePaymentDetailsComponent>
  ) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_LINK_INTERNATIONAL_ENTITY_BANK_ACCOUNT){
        if(resdata.result){
          this.activemodal.close(resdata.result)
        }
      }
    })

  }
  selectedAccount: any = null;
  ngOnInit(): void {
    this.loader = true;
    console.log(this.parentdata.bankAccounts);
    this.parentdata.bankAccounts.forEach((element: any) => {
      element.isSelected = 0;
    });
    this.loader = false;
  }

  selectAccount(item: any) {
    this.parentdata.bankAccounts.forEach((element: any) => {
      element.isSelected = 0;
    });
    item.isSelected = 1;
    this.selectedAccount = item;
  }

  onPost() {
    let obj = {
      hash_id: this.selectedAccount.hashId,
      created_by_account_hash: localStorage.getItem(
        SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
      ),
      entity_hash: this.parentdata.entityHash,
    };

    console.log(obj);
    this.ls.showLoader = true;
    this.apiservice.linkInternationalEntityBankAccount(obj)
  }
  


  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
}
